import { Icon } from "components/Icon/Icon";
import React, { useCallback } from "react";
import {
  useHasProductChanged,
  useProductActions,
  useProductOutput,
  useProductNodeId,
} from "stores/product";
import { useProjectActions } from "stores/project";
import cx from "classnames";
import { UncontrolledTooltip } from "reactstrap";
import { useTranslate } from "hooks";

export const SaveChangesButton = () => {
  const translate = useTranslate();
  const hasProductChanged = useHasProductChanged();
  const productActions = useProductActions();
  const projectActions = useProjectActions();
  const productOutput = useProductOutput();
  const nodeId = useProductNodeId();

  const updateProduct = useCallback(() => {
    if (!hasProductChanged || !nodeId || !productOutput) {
      return;
    }

    projectActions.tree.updateNodeConfiguration({
      nodeId,
      productOutput,
    });

    productActions.syncAfterProductNodeUpdate();
  }, [
    hasProductChanged,
    nodeId,
    productActions,
    productOutput,
    projectActions.tree,
  ]);

  return (
    <>
      <Icon
        iconName="check-regular"
        onClick={updateProduct}
        data-testid="product-configurator-save-icon"
        id="product-configurator-check-regular-icon"
        className={cx("icon-20 text-gray-700 cursor-pointer", {
          "cursor-not-allowed opacity-20 pe-none": !hasProductChanged,
        })}
      />
      <UncontrolledTooltip
        placement="top"
        target="product-configurator-check-regular-icon"
      >
        {translate("PRODUCT_CONFIGURATOR_APPLY_SETTING_BUTTON_TOOLTIP")}
      </UncontrolledTooltip>
    </>
  );
};
